import React from "react";
import Navbar from "../components/Navbar";
import PageTitle from "../components/PageTitle";
import SectionContact from "../components/SectionContact";
import Footer from "../components/Footer";

function Contact() {
	const REACT_APP_MAPS_API_KEY = process.env.REACT_APP_MAPS_API_KEY;

	return (
		<>
			{/* Navbar */}
			<Navbar />

			{/* Page Title */}
			<PageTitle title="Contact" subtitle="Contact" />

			{/* Section 1 - Contact */}
			<SectionContact
				sectionNumber="01"
				bgColor="transparent"
				textColor="dark"
			/>

			{/* Section 2 - Location */}
			<section id="location">
				<div className="container pt-10 pb-20">
					<div className="flex items-center gap-2 lg:gap-6">
						<h1 className="section-title__number">02</h1>
						<h3 className="section-title__text">Location</h3>
					</div>
					<div className="h-[512px] overflow-hidden rounded-2xl">
						<iframe
							title="asd"
							width="100%"
							height="100%"
							loading="lazy"
							allowFullScreen
							referrerPolicy="no-referrer-when-downgrade"
							src={`https://www.google.com/maps/embed/v1/place?q=Washington,DC&zoom=10&key=${REACT_APP_MAPS_API_KEY}`}
						/>
					</div>
				</div>
			</section>

			{/* Footer */}
			<Footer />
		</>
	);
}

export default Contact;
